function Auth() {
    this.client = null;
    this.authCode = null;
    this.authPromiseResolve = null;

    this.load = config => {
        return new Promise((resolve, reject) => {
            const apiUrl = 'https://accounts.google.com/gsi/client';
            const script = document.createElement('script');
            script.src = apiUrl;
            script.id = 'gsi-script';
            script.onload = () => {
                try {
                    this.client = window.google.accounts.oauth2.initCodeClient({
                        client_id: config.clientId,
                        scope: config.scope,
                        callback: this.handleCredentialResponse,
                        error_callback: this.signOut,
                    });
                    resolve();
                } catch (error) {
                    // eslint-disable-next-line prefer-promise-reject-errors
                    reject('Failed to initialize client: ', error);
                }
            };
            script.onerror = reject;
            document.getElementsByTagName('head')[0].appendChild(script);
        });
    };

    this.handleCredentialResponse = response => {
        this.authCode = response.code;

        if (this.authPromiseResolve) {
            this.authPromiseResolve(this.authCode);
            this.authPromiseResolve = null;
        }
    };

    this.getAuthCode = () => {
        if (this.authCode) {
            return Promise.resolve(this.authCode);
        }

        return new Promise(resolve => {
            this.authPromiseResolve = resolve;
            this.client.requestCode();
        });
    };

    this.signOut = () => {
        if (this.client) {
            this.client = null;
            this.authCode = null;
            this.authPromiseResolve = null;
        }
        window.location.reload();
    };
}

const gAuth = new Auth();

export default gAuth;
